import type { ReactNode } from 'react';
import {
  LegacyModal,
  LegacyModalContent,
  LegacyModalContentHeader,
  LegacyModalContentBody,
  LegacyModalContentFooter,
} from '../../../legacy/LegacyModal';
import { Button } from '../../navigation/Button/Button';
import { Link } from '../../navigation/Link';
import { Markdown } from '../../display/Markdown/Markdown';

import styles from './PolicyModal.module.scss';

type Props = {
  /** Title of the policy. */
  title: string;

  /** A description of what's changed in the policy. */
  tldr: string;

  /** URL of the policy page to view more. */
  url?: string;

  /** Callback for when acceptance button is clicked. */
  onAccept: () => void;

  /** Function to render markdown. */
  renderMarkdown?: (markdown: string) => ReactNode;
};

/** A `LegacyModal` component for displaying policies to review and accept. */
export const PolicyModal = ({
  onAccept,
  title,
  tldr,
  url,
  renderMarkdown = (markdown) => <Markdown>{markdown}</Markdown>,
}: Props) => {
  return (
    <LegacyModal canClose={false} onClosed={() => {}}>
      <LegacyModalContent maxWidth="70ch">
        <LegacyModalContentHeader>
          <h1 data-zds className={styles.title}>
            We've updated the {title}
          </h1>
        </LegacyModalContentHeader>
        <LegacyModalContentBody scrollable={true}>
          <div className={styles.markdown} data-zds>
            {renderMarkdown(tldr)}
          </div>
        </LegacyModalContentBody>
        <LegacyModalContentFooter>
          {!!url && (
            <Link href={url} target="_blank" variant="secondary">
              Review changes
            </Link>
          )}
          <Button variant="primary" onPress={onAccept}>
            Accept
          </Button>
        </LegacyModalContentFooter>
      </LegacyModalContent>
    </LegacyModal>
  );
};
